import { FileHelper } from '../../helpers/file-helper';
import { FileService } from './../../services/file.service';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { FileTypes } from '../../enums/file-types';
import { ImageCroppperResponse } from '../../models/image-cropper-resp';
import { AppModalComponent } from '../app-modal/app-modal.component';
import { ModalConfig } from '../../models/modal.config';
import { ModalConfigHelper } from '../../helpers/modal-config-helper';
import { Observable, of } from 'rxjs';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss'],
})
export class ImageCropperComponent implements OnInit {
  @ViewChild('attachmentmodal') private modalComponent: AppModalComponent;
  modalConfig: ModalConfig;
  @Output() imageCropperEvent = new EventEmitter<ImageCroppperResponse>();
  @Input() shouldUploadFile: boolean;
  @Input('buttonTitle') buttonTitle: string;
  @ViewChild('fileInput') fileInputElement: ElementRef;
  imgChangeEvt: any = '';
  cropImgPreview: any = '';
  uploadStatus: string;
  imageExtensions = FileHelper.getExtensionsByFileType(FileTypes.Image);
  invalidFileType = false;
  imageCroppperResponse: ImageCroppperResponse;
  isFileUploaded = false;
  message: string;

  constructor(private _fileService: FileService) {
    this.modalConfig = ModalConfigHelper.getAtachmentModalConfig(
      this.onDismiss,
      this.doneWithCroppingEvent
    );
    this.imageCroppperResponse = {
      file: null,
      filePath: null,
      isFileUploaded: this.shouldUploadFile,
    };
  }

  ngOnInit() { }

  onFileChange(event: any): void {
    this.invalidFileType = false;
    this.imgChangeEvt = event;
  }

  cropImg(e: ImageCroppedEvent) {
    this.cropImgPreview = e.base64;
  }

  imgLoad() {
    this.modalComponent.open();
  }

  initCropper() { }

  imgFailed() {
    this.invalidFileType = true;
  }

  doneWithCroppingEvent = async () => {
    const file = ((this.imgChangeEvt as Event).target as any).files[0] as File;
    const imageBase64 = this.cropImgPreview as string;
    const imageFile = FileHelper.convertBase64ToFile(
      imageBase64,
      file.name,
      file.type
    );
    this.imgChangeEvt = this.cropImgPreview = '';
    this.fileInputElement.nativeElement.value = '';

    if (this.shouldUploadFile) {
      this.uploadStatus = 'File is uploading.';
      const resp = this.uploadFile(imageFile);
    } else {
      this.imageCroppperResponse.file = imageFile;
    }
    return of<boolean>(true);
  };

  uploadFile = async (file: File) => {
    const formData = new FormData();
    formData.append(
      'acceptedFiles',
      FileHelper.getExtensionsByFileType(FileTypes.Image)
    );
    formData.append('file', file, file.name);
      if(file.size > 2*(1024*1024)) {
        alert("File is more than 2MB. Please choose a smapper file.");
        return;
      }

    const fileRequest = { formData: formData, reportProgress: true };
    return await this._fileService
      .uploadFile(fileRequest.formData)
      .subscribe((event) => {
        if (event.type === HttpEventType.Response) {
          this.uploadStatus = 'File uploading completed.';
          this.isFileUploaded = true;
          this.imageCroppperResponse.filePath = event.body['dbPath'];
          if (!this.imageCroppperResponse.filePath) {
            this.uploadStatus = 'Unable to upload the file.';
            return false;
          }
          setTimeout(() => {
            this.uploadStatus = '';
          }, 500);
          this.imageCropperEvent.emit(this.imageCroppperResponse);
          this.isFileUploaded = false;
        }
      });
  };

  onClose = (): Observable<boolean> => {
    return of<boolean>(true);
  };

  onDismiss = (): Observable<boolean> => {
    return of<boolean>(true);
  };
}
